import { render, staticRenderFns } from "./LangComponent.vue?vue&type=template&id=9e6e1e7e&"
import script from "./LangComponent.vue?vue&type=script&lang=js&"
export * from "./LangComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports